import React from 'react';
import {
  Input,
  Button,
  CheckboxTable,
  Select,
  PaperClip,
  DatePicker,
} from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Colors, Print } from 'utils';
import moment from 'moment';
import { FormalityService } from 'services';
import { connect } from 'react-redux';

interface Props extends RootState {
  onClose?: any;
  item?: any;
}

declare var window: any;

class ModalView extends React.Component<Props> {
  state = {
    formality: null,
  };

  componentDidMount() {
    this.load();
  }

  load = async () => {
    const res: any = await FormalityService.view({
      formality_id: this.props.item?.id,
    });
    this.setState({
      formality: res.formality,
    });
  };

  submit = async () => {
    const formality: any = this.state.formality;
    const tags = formality.tags.filter((i: any) => !i.value);

    if (tags.length > 0) {
      Globals.showError('Por favor, ingrese todos los valores para continuar');
      return;
    }

    const res: any = await FormalityService.generate({
      formality_id: this.props.item?.id,
      tags: JSON.stringify(formality.tags),
      user_id: this.props.user?.id,
    });
    this.props.onClose(true);
    if (window.webkit && window.webkit.messageHandlers) {
      const message = 'open_url';
      const sendToNative = {
        message,
        url: Constants.BASE_STORAGE + res.url,
      };
      const stringifiedMessageObj = JSON.stringify(sendToNative);
      window.webkit.messageHandlers.cordova_iab.postMessage(
        stringifiedMessageObj,
      );
    } else {
      Print(Constants.BASE_STORAGE + res.url);
    }
  };

  changeTag = (e: any, index: number) => {
    let formality: any = this.state.formality;
    formality.tags[index].value = e.target.value;
    this.setState({
      formality,
    });
  };

  render() {
    const formality: any = this.state.formality;

    return (
      <div id="modal-view-formality">
        <div className="container-white">
          <div className="container-inputs">
            {formality?.tags?.map((item: any, index: number) => {
              return (
                <Input
                  label={item.name}
                  name={item.tag}
                  value={item.value}
                  onChange={(e: any) => this.changeTag(e, index)}
                />
              );
            })}
          </div>
          <div className="text-center">
            <button className="btn btn-submit" onClick={() => this.submit()}>
              Generar documento
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(ModalView);
